// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/Styles/MessageList.css
// module id = 2489
// module chunks = 0